import {AfterViewInit, Component, EventEmitter, Inject, OnDestroy, OnInit, Output, ViewChild} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {Subscription} from "rxjs";
import {GrupoCarteira} from "../../grupo-carteira";
import {CadastroGrupoCarteiraComponent} from "../../cadastro-grupo-carteira/cadastro-grupo-carteira.component";

@Component({
  selector: "modal-editar-grupo-carteira",
  templateUrl: "modal-editar-grupo-carteira.component.html",
})
export class ModalEditarGrupoCarteiraComponent
  implements AfterViewInit, OnDestroy, OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: GrupoCarteira
  ) {
    this.grupoCarteira = data
  }

  @Output() editado = new EventEmitter();
  private readonly subscriptions = new Subscription();

  @ViewChild("editarGrupoCarteiraComponent", {static: false})
  private readonly component: CadastroGrupoCarteiraComponent;
  grupoCarteira: GrupoCarteira;

  form: FormGroup;

  ngAfterViewInit(): void {
  }

  ngOnInit() {
  }

  grupoCarteiraEditado() {
    this.editado.emit();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
